<template>
  <page-section
    :section-name="name"
    :content="textContent"
    class="bg-white"
    v-slot="{ content }"
  >
    <h3>{{ content.title }}</h3>
    <p v-html="content.body[0]" class="text-blue" />
    <p v-html="content.body[1]" />
    <p v-html="content.body[2]" />
    <carousel
      navigation-enabled
      pagination-active-color="#be212e"
      pagination-color="#000000"
      class="mb-5"
    >
      <slide v-for="index of 4" :key="`${name}-slide-${index - 1}`">
        <img
          :src="slides[index - 1].image"
          :alt="slides[index - 1].alt"
          width="5"
          height="3.5"
          class="w-full h-auto"
          v-if="loaded"
        />
      </slide>
    </carousel>
    <p v-html="content.body[3]" />
    <carousel
      navigation-enabled
      pagination-active-color="#be212e"
      pagination-color="#000000"
      class="mb-5"
    >
      <slide v-for="index of 4" :key="`${name}-slide-${index + 3}`">
        <img
          :src="slides[index + 3].image"
          :alt="slides[index + 3].alt"
          width="5"
          height="3.5"
          class="w-full h-auto"
          v-if="loaded"
        />
      </slide>
    </carousel>
    <p v-html="content.body[4]" />
  </page-section>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "ConnectingAcrossBorders",
  components: {
    pageSection: () => import("@/components/PageSection.vue"),
    Carousel,
    Slide,
  },
  data() {
    return {
      name: "connectingAcrossBorders",
      slides: [
        {
          image: require("../assets/images/Photos/Connecting_across_borders/Slides/joanna_erdman_expert_exchanges_credit_likhaan_1.jpg"),
          alt: this.$t("i18nAlt[18]"),
        },
        {
          image: require("../assets/images/Photos/Connecting_across_borders/Slides/joanna_erdman_expert_exchanges_credit_likhaan_2.jpg"),
          alt: this.$t("i18nAlt[19]"),
        },
        {
          image: require("../assets/images/Photos/Connecting_across_borders/Slides/joanna_erdman_expert_exchanges_credit_likhaan_3.jpg"),
          alt: this.$t("i18nAlt[20]"),
        },
        {
          image: require("../assets/images/Photos/Connecting_across_borders/Slides/joanna_erdman_expert_exchanges_credit_likhaan_4.jpg"),
          alt: this.$t("i18nAlt[21]"),
        },
        {
          image: require("../assets/images/Photos/Connecting_across_borders/Slides/jennifer_gibson_expert_exchanges_credit_likhaan_1.jpg"),
          alt: this.$t("i18nAlt[22]"),
        },
        {
          image: require("../assets/images/Photos/Connecting_across_borders/Slides/jennifer_gibson_expert_exchanges_credit_likhaan_2.jpg"),
          alt: this.$t("i18nAlt[23]"),
        },
        {
          image: require("../assets/images/Photos/Connecting_across_borders/Slides/jennifer_gibson_expert_exchanges_credit_likhaan_3.jpg"),
          alt: this.$t("i18nAlt[24]"),
        },
        {
          image: require("../assets/images/Photos/Connecting_across_borders/Slides/jennifer_gibson_expert_exchanges_credit_likhaan_4.jpg"),
          alt: this.$t("i18nAlt[25]"),
        },
      ],
      loaded: false,
    };
  },
  computed: {
    textContent() {
      const { name } = this;

      return this.$t(`i18nSections.${name}`);
    },
  },
  mounted() {
    // This is needed to make sure the carousel loads properly.
    window.addEventListener("load", () => (this.loaded = true));
  },
};
</script>
